import * as React from "react";
import Svg, { Path, Defs, ClipPath, Rect, G } from "react-native-svg";
const XIcon = ({ customColor, ...props }) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <G clipPath="url(#clip0_8103_16138)">
            <Path d="M12.6654 4.27398L11.7254 3.33398L7.9987 7.06065L4.27203 3.33398L3.33203 4.27398L7.0587 8.00065L3.33203 11.7273L4.27203 12.6673L7.9987 8.94065L11.7254 12.6673L12.6654 11.7273L8.9387 8.00065L12.6654 4.27398Z" fill={customColor ?? "#CB494B"} />
        </G>
        <Defs>
            <ClipPath id="clip0_8103_16138">
                <Rect width="16" height="16" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>

);
export default XIcon;
